import React, { useEffect, useState } from 'react'
import picture from '../images/gallery-img2.jpg'

import { firestore } from '../firebase';
import { 
    collection,
    getDocs
} from "firebase/firestore";

const Galery = () => {

  const [galeria, setGaleria] = useState([])

  useEffect(() => {
    async function fetchData() {
        const querySnapshot = await getDocs(collection(firestore, "galeria"));
        querySnapshot.forEach((doc) => {
            setGaleria(((prev) => [...prev, doc.data()]))
        })
        
      }
      fetchData();
    }, [])

  return (
    <section>
    <section className="page-heading">
    <div className="container">
      <h2>GALERIA</h2>
    </div>
  </section>
  <section
    className="gallery-images-section"
    itemProp="image"
    itemScope=""
    itemType=" http://schema.org/ImageGallery"
  >
    {galeria.map((imagen)=>{
      return <div className="gallery-img-wrap" key={imagen.url}>
        <a
          href={imagen.url}
          data-lightbox="example-set"
          data-title="Click the right half of the image to move forward."
        >
          <img src={imagen.url} alt="gallery-images" />
        </a>
      </div>
    })}
    
  </section>
  </section>
  )
}

export default Galery